/**
 * @generated SignedSource<<d66d8ecbcaaaa86ae6f9d77167b3011d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LiquidDelegationRulesFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BlocksBeforeVoteClosesRuleFragment" | "CustomRulesFragment" | "PermissionsRuleFragment" | "RedelegationRuleFragment" | "TimeRuleFragment">;
  readonly " $fragmentType": "LiquidDelegationRulesFragment";
};
export type LiquidDelegationRulesFragment$key = {
  readonly " $data"?: LiquidDelegationRulesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"LiquidDelegationRulesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LiquidDelegationRulesFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PermissionsRuleFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RedelegationRuleFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeRuleFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CustomRulesFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlocksBeforeVoteClosesRuleFragment"
    }
  ],
  "type": "LiquidDelegationRules",
  "abstractKey": null
};

(node as any).hash = "8ea5e470bac565eb6e93145c297d3fe0";

export default node;
